import httpClient from '../httpClient';

export const getCartList = async (idCustomer, zipcode, idStore) => {
  const result = await httpClient.get('/cart/get', {
    params: {
      idCustomer: idCustomer,
      zipcode: zipcode,
      idStore: idStore,
    },
  });
  return result.data;
};
export const addCart = async (idCustomer, idStyle, color, totQty) => {
  const result = await httpClient.get('/cart/add', {
    params: {
      idCustomer: idCustomer,
      idStyle: idStyle,
      color: color,
      totQty: totQty,
    },
  });
  return result.data;
};
export const updateCart = async (
  idCustomer,
  zipcode,
  idStyle,
  idStyleDtl,
  totQty,
) => {
  const result = await httpClient.get('/cart/set', {
    params: {
      idCustomer: idCustomer,
      idStyle: idStyle,
      idStyleDtl: idStyleDtl,
      zipcode: zipcode,
      totQty: totQty,
    },
  });
  return result.data;
};
export const removeCart = async (idCustomer, idCartDtl) => {
  const result = await httpClient.get('/cart/remove', {
    params: {
      idCustomer: idCustomer,
      idCartDtl: idCartDtl,
    },
  });
  return result.data;
};

export const getCartShippingMethod = async (idCustomer) => {
  const result = await httpClient.get('/cart/shipping-method', {
    params: {
      idCustomer: idCustomer,
    },
  });
  return result.data;
};
